import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Wallet.css';

function Wallet() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('wallet');
  const user = JSON.parse(localStorage.getItem('user') || 'null');

  const balance = 25.00;
  const transactions = [
    { id: 1, type: 'credit', title: 'Added to wallet', amount: 20, date: 'Today', icon: '💳' },
    { id: 2, type: 'debit', title: 'Ride to Penn Station', amount: -8, date: 'Yesterday', icon: '🚗' },
    { id: 3, type: 'credit', title: 'Referral bonus', amount: 5, date: 'Nov 28', icon: '🎁' },
    { id: 4, type: 'debit', title: 'Math Tutoring', amount: -15, date: 'Nov 27', icon: '📚' },
    { id: 5, type: 'credit', title: 'Added to wallet', amount: 50, date: 'Nov 25', icon: '💳' }
  ];

  const quickAmounts = [10, 20, 50, 100];

  return (
    <div className="wallet-page">
      {/* Header */}
      <header className="wallet-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1>Wallet</h1>
        <div className="header-spacer"></div>
      </header>

      {/* Balance Card */}
      <section className="balance-section">
        <div className="balance-card">
          <div className="balance-bg"></div>
          <div className="balance-content">
            <span className="balance-label">Available Balance</span>
            <h2 className="balance-amount">${balance.toFixed(2)}</h2>
            <div className="balance-actions">
              <button className="balance-action" onClick={() => navigate('/wallet/add')}>
                <span className="action-icon">+</span>
                <span>Add Money</span>
              </button>
              <button className="balance-action">
                <span className="action-icon">↗</span>
                <span>Send</span>
              </button>
              <button className="balance-action">
                <span className="action-icon">📋</span>
                <span>History</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Add */}
      <section className="quick-add-section">
        <h3 className="section-title">Quick Add</h3>
        <div className="quick-amounts">
          {quickAmounts.map((amount) => (
            <button key={amount} className="quick-amount-btn">
              ${amount}
            </button>
          ))}
        </div>
      </section>

      {/* Payment Methods */}
      <section className="payment-methods-section">
        <h3 className="section-title">Payment Methods</h3>
        <div className="payment-methods-list">
          <div className="payment-method-item">
            <div className="method-icon">💳</div>
            <div className="method-info">
              <span className="method-name">•••• 4242</span>
              <span className="method-type">Visa</span>
            </div>
            <span className="method-default">Default</span>
          </div>
          <button className="add-method-btn">
            <span>+</span>
            <span>Add Payment Method</span>
          </button>
        </div>
      </section>

      {/* Transactions */}
      <section className="transactions-section">
        <div className="section-header">
          <h3 className="section-title">Recent Transactions</h3>
          <button className="see-all">See All</button>
        </div>
        <div className="transactions-list">
          {transactions.map((tx) => (
            <div key={tx.id} className="transaction-item">
              <div className="tx-icon">
                <span>{tx.icon}</span>
              </div>
              <div className="tx-info">
                <span className="tx-title">{tx.title}</span>
                <span className="tx-date">{tx.date}</span>
              </div>
              <span className={`tx-amount ${tx.type}`}>
                {tx.type === 'credit' ? '+' : ''}{tx.amount < 0 ? '-' : ''}${Math.abs(tx.amount).toFixed(2)}
              </span>
            </div>
          ))}
        </div>
      </section>

      {/* Promo Code */}
      <section className="promo-section">
        <div className="promo-input-wrapper">
          <input
            type="text"
            placeholder="Enter promo code"
            className="promo-input"
          />
          <button className="apply-btn">Apply</button>
        </div>
      </section>
    </div>
  );
}

export default Wallet;
